<template lang="pug">
    div(v-if="results.length > 0")
        //- This default slot allows us to use this component to display something if we have results
        slot
            slot(name="results" :results="results" :resultCount="resultCount")
                slot(
                    v-for="(result, index) in results"
                    name="result"
                    :result="result"
                    :resultCount="resultCount"
                    :index="index"
                )

</template>

<script>
import SearchComponent from './component'

export default {
    extends: SearchComponent,
    computed: {
        results() {
            return this.$searchContext.state.results
        },
        resultCount() {
            return this.$searchContext.state.resultCount
        },
    },
}
</script>
